import { restSinNegocio } from "@/utils/restaurantes.utils.js";
import { db, storage } from '@/firebase';
export default {
  getRestaurante({ rootState, state, commit }) {
    console.log(rootState.restaurante.listadoRestaurantes);
    var found = rootState.restaurante.listadoRestaurantes.find(
      r => restSinNegocio(r) == state.restaurante
    );
    if (found) {
      commit('setRestauranteObj', found);
    } else {
      return Promise.reject("not-found")
    }
  },
  //Productos para mostrar la carta
  getProductosCategorias({ state, commit, rootState }) {
    let n = rootState.propio.negocioPropio;
    let r = state.restaurante;
    var productos = db.collection('negocios').doc(n).collection('productos')
      .get()
      .then((r) => {
        let res = [];
        let docs = r.docs;
        docs.forEach(e => {
          let d = e.data();
          d.id = e.id;
          res.push(d);
        });
        return res;
      })
      .then((res) => {
        var actions = res.map(function (item) {
          var storageRef = storage.ref('imagenes/productos/' + item.id + '.jpg');
          //var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
          return storageRef.getDownloadURL()
            .then((r) => {
              item.imagen = r;
              return item;
            })
            .catch((e) => {
              item.imagen = false;
              return item;
            })
        });
        Promise.all(actions)
          .then((r) => {
            commit('setProductos', r)
          })
      });
    let categorias = db.collection('negocios').doc(n).collection('categorias')
      .get()
      .then((r) => {
        let res = [];
        let docs = r.docs;
        docs.forEach(e => {
          let d = e.data();
          d.id = e.id;
          res.push(d);
        });
        console.log(res);
        commit('setCategorias', res)
      });
    var descuentos = db.collection('negocios').doc(n).collection('descuentos')
      .get()
      .then((r) => {
        let res = [];
        let docs = r.docs;
        docs.forEach(e => {
          let d = e.data();
          d.id = e.id;
          res.push(d);
        });
        commit('setDescuentos', res)
      });
    return Promise.all([productos, categorias, descuentos])
  },
}